// extracted by mini-css-extract-plugin
export default {"admin":"AdminRoutes_admin__PKVC1","nav-bar":"AdminRoutes_nav-bar__c3i-h","content":"AdminRoutes_content__ag7FO"};